import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    targetTag: null,
    messageId: null,
};

export const slice = createSlice({
    name: 'highlights',
    initialState,
    reducers: {
        setHighlightsNavigation: (state, {payload}) => {
            const {targetTag = null, messageId = null} = payload ?? {};

            state.targetTag = targetTag;
            state.messageId = messageId;

            return state;
        },
        clearHighlightsNavigation: (state) => {
            state.targetTag = null;
            state.messageId = null;

            return state;
        },
    },
});

export const {setHighlightsNavigation, clearHighlightsNavigation} = slice.actions;

export default slice.reducer;
